export const FETCH_REGIONS_REQUEST = 'FETCH_REGIONS_REQUEST';
export const FETCH_REGIONS_RECEIVE = 'FETCH_REGIONS_RECEIVE';

export const SELECT_REGION = 'SELECT_REGION';
export const SELECT_TIME_SPAN = 'SELECT_TIME_SPAN';

export const FETCH_MESSAGE_REQUEST = 'FETCH_MESSAGE_REQUEST';
export const FETCH_MESSAGE_RECEIVE = 'FETCH_MESSAGE_RECEIVE';

export const FETCH_GRAPH_REQUEST = 'FETCH_GRAPH_REQUEST';
export const FETCH_GRAPH_RECEIVE = 'FETCH_GRAPH_RECEIVE';



// WEBPACK FOOTER //
// ./src/constants/actions.js